class WhatsInBravo extends HTMLElement {
  constructor() {
    super();
    this.stageElement = null;
    this.intersectionObserver = null;
  }

  connectedCallback() {
    this.stageElement = this.querySelector('.whats-in-bravo__stage');

    if (!this.stageElement) return;

    if (!('IntersectionObserver' in window)) {
      this.setAttribute('is-in-view', '');
      return;
    }

    this.setupObserver();
  }

  disconnectedCallback() {
    this.intersectionObserver?.disconnect();
  }

  setupObserver() {
    const { stageElement } = this;
    if (!stageElement) return;

    this.intersectionObserver?.disconnect();
    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;

        if (entry.isIntersecting && entry.intersectionRatio >= 1) {
          this.setAttribute('is-in-view', '');
          return;
        }

        this.removeAttribute('is-in-view');
      },
      {
        threshold: [0, 1],
      }
    );

    this.intersectionObserver.observe(stageElement);
  }
}

if (!customElements.get('whats-in-bravo')) {
  customElements.define('whats-in-bravo', WhatsInBravo);
}
